var map = {
	"./Coin.png": "8561",
	"./P3-scaled.jpg": "48ac",
	"./Pro-1.jpg": "c9f4",
	"./Pro-2.jpg": "2ead",
	"./Pro-3.jpg": "bfda",
	"./Pro-4.jpg": "3ef4",
	"./Shiba-BG.jpg": "12e1",
	"./Shiba-BG111.jpg": "6041",
	"./addfriend.png": "b403",
	"./addfriend2.png": "37f2",
	"./ai.png": "d24f",
	"./ai3.png": "ee26",
	"./aladin.jpg": "a190",
	"./analysis.png": "8d6f",
	"./angpao.png": "dafc",
	"./askmebet-support.png": "4c53",
	"./avartar.png": "0a55",
	"./avatar-01.jpg": "5f80",
	"./bank/baac.jpg": "e45b",
	"./bank/bankokbank.jpg": "029f",
	"./bank/cimb.jpg": "3a74",
	"./bank/clicx.png": "58d3",
	"./bank/ez-casino-payment-bank-citi.png": "639d",
	"./bank/ghbank.jpg": "d1a9",
	"./bank/gsb.jpg": "d79f",
	"./bank/icbc.jpg": "9bed",
	"./bank/kbank.jpg": "25e9",
	"./bank/kiatnakin.jpg": "f79e",
	"./bank/krungsri.jpg": "6827",
	"./bank/ktb.jpg": "ed77",
	"./bank/lh.jpg": "d9be",
	"./bank/scb.jpg": "c6ff",
	"./bank/standard.jpg": "ac03",
	"./bank/tisco.jpg": "3b85",
	"./bank/tmw.png": "709f",
	"./bank/truewallet.jpg": "6466",
	"./bank/ttb.jpg": "2906",
	"./bank/uob.jpg": "5191",
	"./bank/ธนาคารอิสลาม.jpg": "0387",
	"./betflix-support.png": "ec8d",
	"./bg_home.jpg": "8435",
	"./bg_wedo.jpg": "cd84",
	"./bkg_jackpot.png": "46d0",
	"./btn_hover.png": "7dbd",
	"./casino.png": "ad84",
	"./casino2.png": "1758",
	"./checkin.png": "d7a6",
	"./coin1.png": "c688",
	"./contact.png": "dfe7",
	"./dolla.png": "d91c",
	"./done.png": "9cda",
	"./edmbet-support.png": "c6b61",
	"./ez-slot-ic-coin.png": "4450",
	"./ez-slot-ic_deposit_mobile.png": "d325",
	"./ez-slot-ic_lobby_mobile.png": "7f10",
	"./ez-slot-ic_lobby_mobile_play.png": "3cf2",
	"./ez-slot-ic_withdraw_mobile.png": "0a47",
	"./favorite.png": "694c",
	"./favorite150.png": "c8a9",
	"./game-console.png": "c322",
	"./gift-box.png": "f204",
	"./gift.png": "f9fd",
	"./gl-logo.png": "bf35",
	"./hackslot/btn-switch.png": "555e",
	"./hackslot/topic01.png": "9d3a",
	"./hackslot/topic02.png": "b0f0",
	"./hackslot/topic03.png": "e8b6",
	"./hackslot/topic04.png": "db74",
	"./hackslot/topic05.png": "a3fd",
	"./hackslot/topic06.png": "81a4",
	"./hackslot/topic07.png": "5b82",
	"./hackslot/topic08.png": "783b",
	"./ic-gift.png": "1e47",
	"./icdeposit.png": "4b43",
	"./icon-fb-bttm.jpg": "6d98",
	"./icon-line.svg": "17f6",
	"./icon-play.png": "b426b",
	"./icons/favicon.ico": "647d",
	"./icons/icon-google.png": "8bf1",
	"./icwithdraw.png": "514b",
	"./img-01.jpg": "d695",
	"./imiwin-support.png": "0be6",
	"./jackpot.png": "6a07",
	"./line-glow-blue.png": "14d9",
	"./line.png": "fe82",
	"./logo-headline65x400.png": "02ee",
	"./logo-landscape.png": "3a72",
	"./logo-shiba888.png": "59a1",
	"./logout.png": "735a",
	"./lotto.png": "73b5",
	"./menu/Menu-01-.png": "b9f5",
	"./menu/Menu-01.png": "e354",
	"./menu/Menu-02.png": "b72b",
	"./menu/Menu-03.png": "a7c0",
	"./menu/Menu-04.png": "05e0",
	"./menu/Menu-05.png": "1d30",
	"./menu/Menu-06.png": "c077",
	"./menu/Menu-07.png": "283e",
	"./menu/Menu-08.png": "56ca",
	"./menu/Menu-09.png": "b426",
	"./menu/Menu-10.png": "f8d1",
	"./menu/Menu-11-.png": "bb61",
	"./menu/Menu-11.png": "6925",
	"./menu/Menu-12.png": "263f",
	"./menu/friend-1.png": "1e94",
	"./menu/icon-play2.png": "d91e",
	"./menu/main-menu-cow888-13.png": "07f8",
	"./menu/main-menu-cow888-14.png": "a7fe",
	"./menu/main-menu-cow888-15.png": "3282",
	"./menu/money-1.png": "9975",
	"./menu/play-1.png": "be05",
	"./menu/promotion-1.png": "1aff",
	"./merry.jpg": "eb43",
	"./money.mp3": "8f0b",
	"./natural-paper-texture.jpg": "74e8",
	"./note.png": "0571",
	"./point.png": "4fc8",
	"./research.png": "1970",
	"./roulet.png": "6e85",
	"./santa.png": "eeb0",
	"./scratch.png": "7305",
	"./shiba-loading.gif": "7a49",
	"./shiba-loading.png": "aa3e",
	"./shiba888-curve-bottom.png": "55a8",
	"./shiba888-curve-top.png": "40c6",
	"./shiba888-ic-coin.png": "1a28",
	"./shiba888-ic-menu-logout.png": "1ccc",
	"./shiba888-ic-menu-promotion.png": "179c",
	"./shiba888-ic-menu-user.png": "5235",
	"./shiba888-ic-mobile-left-1.png": "34bb",
	"./shiba888-ic-mobile-left-2.png": "94e1",
	"./shiba888-ic-mobile-right-1.png": "2dcd",
	"./shiba888-ic-mobile-right-2.png": "33a4",
	"./shiba888-profile-icon-level-02.png": "3877",
	"./spin.png": "9e89",
	"./surprise.png": "ec60",
	"./title-shiba.png": "b56f",
	"./title-shiba111.png": "d3e0",
	"./treasure.png": "0edd",
	"./ufa-bet-support.png": "2bd1",
	"./waiting.png": "0c5f",
	"./wedo_pict01.png": "bf90",
	"./wedo_pict02.png": "ba9b",
	"./wedo_pict03.png": "053b",
	"./wedo_pict04.png": "2012",
	"./wedo_pict05.png": "3375",
	"./wedo_pict06.png": "3d54",
	"./wheelbackgroundfinal.png": "125d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";